<template>

  <svgicon class="edit-button" name="pencil" title="Edit" @click="$emit('click')"></svgicon>

</template>

<script>
import '@/assets/icons/pencil'

export default {
  name: 'EditButton'
}
</script>

<style lang="scss" scoped>
@import '../../styles/main-colors';

.edit-button {
  fill: $poison-c;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/common/EditButton.vue